import { render, staticRenderFns } from "./RegisterSubModuleBasic.vue?vue&type=template&id=f090cbb4&scoped=true&"
import script from "./RegisterSubModuleBasic.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModuleBasic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModuleBasic.vue?vue&type=style&index=0&id=f090cbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f090cbb4",
  null
  
)

export default component.exports